/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização da div
 */
export default styled.div`
  display: contents;

  @media (max-width: 768px) {
    display: none;
  }
`;
